var _defs, _rect, _circle, _rect2, _circle2, _circle3, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditAgent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 16,
    y1: 20,
    x2: 140,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#10B981"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "face",
    x1: 42,
    y1: 44,
    x2: 120,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F172A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E293B"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 144,
    height: 144,
    rx: 36,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 50,
    fill: "url(#face)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 60,
    width: 52,
    height: 40,
    rx: 12,
    fill: "#0B1220",
    stroke: "#5EEAD4",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 67,
    cy: 80,
    r: 7,
    fill: "#5EEAD4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 93,
    cy: 80,
    r: 7,
    fill: "#5EEAD4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 107,
    width: 32,
    height: 6,
    rx: 3,
    fill: "#34D399"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 35,
    width: 12,
    height: 12,
    rx: 4,
    fill: "#A7F3D0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 25,
    width: 4,
    height: 12,
    rx: 2,
    fill: "#D1FAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditAgent);
export default __webpack_public_path__ + "static/media/audit-agent.8808d26725044f7daea9c1af7f9e1980.svg";
export { ForwardRef as ReactComponent };